module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_IS-64a614937ad6ea069b6b566be572b018.svg";